import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//import { BasicAuthGuard } from './routing/basic-auth-guard'
import {CreateEditUserComponent} from "./pages/users/create-edit-user/create-edit-user.component";
import {UserViewComponent} from "./pages/users/user-view/user-view.component";
import {
  SavedSearchesContainerComponent
} from "./pages/users/saved-searches-management/saved-searches-container/saved-searches-container.component";
import {
  FundingGoalsManagementComponent
} from "./pages/users/funding-goals-management/funding-goals-management.component";
import {LoggedOutComponent} from "./pages/logged-out/logged-out.component";
import {LoginComponent} from "./pages/login/login.component";
import {PageNotFoundComponent} from "./pages/page-not-found/page-not-found.component";
import {UnauthorizedComponent} from "./pages/unauthorized/unauthorized.component";
import {
  FundingGoalsListingComponent
} from "./pages/users/funding-goals-management/funding-goals-listing/funding-goals-listing.component";
import {ChangePasswordComponent} from "./pages/users/change-password/change-password.component";
import {DashboardComponent} from "./pages/users/dashboard/dashboard.component";
import {SubscriptionManagementComponent} from "./pages/users/subscription-management/subscription-management.component";
import {
  SearchDonorsDetailsComponent
} from "./pages/search-nonprofits-donors/search-donors-details/search-donors-details.component";
import {
  SearchDonorsPageComponent
} from "./pages/search-nonprofits-donors/search-donors-page/search-donors-page.component";

import {
  SearchNonprofitsDetailsComponent
} from "./pages/search-nonprofits-donors/search-nonprofits-details/search-nonprofits-details.component";
import {
  SearchNonprofitsPageComponent
} from "./pages/search-nonprofits-donors/search-nonprofits-page/search-nonprofits-page.component";
import {SearchGrantsPageComponent} from "./pages/search-grants/search-grants-page/search-grants-page.component";
import {
  SearchGrantsDetailsComponent
} from "./pages/search-grants/search-grants-details/search-grants-details.component";
import {ForgotUsernameComponent} from "./pages/forgot-username/forgot-username.component";
import {
  ResetPasswordRequestComponent
} from "./pages/reset-password/reset-password-request/reset-password-request.component";
import {ResetPasswordComponent} from "./pages/reset-password/reset-password.component";
import {
  SavedSearchesDonorCreateEditComponent
} from "./pages/users/saved-searches-management/saved-searches-create-edit/saved-searches-donor-create-edit/saved-searches-donor-create-edit.component";
import {
  SavedSearchesGrantCreateEditComponent
} from "./pages/users/saved-searches-management/saved-searches-create-edit/saved-searches-grant-create-edit/saved-searches-grant-create-edit.component";
import {
  SavedSearchesNonprofitCreateEditComponent
} from "./pages/users/saved-searches-management/saved-searches-create-edit/saved-searches-nonprofit-create-edit/saved-searches-nonprofit-create-edit.component";
import {
  SubscriptionPaymentComponent
} from "./pages/users/subscription-management/subscription-payment/subscription-payment.component";
import {WishListListingComponent} from "./pages/users/wishlist/wishlist-listing/wishlist-listing.component";
import {CreateViewWishlistComponent} from "./pages/users/wishlist/create-view-wishlist/create-view-wishlist.component";
import {AuthGuard} from "./routing/auth-guard.service";
import {
  SuccessfulPaymentComponent
} from "./pages/users/subscription-management/success-payment/successful-payment.component";
import {
  CanceledPaymentComponent
} from "./pages/users/subscription-management/canceled-payment/canceled-payment.component";
import {
  SuccessfulSubscriptionChangeComponent
} from "./pages/users/subscription-management/success-subscription-change/successful-subscription-change.component";
import {
  SubscriptionChangeComponent
} from "./pages/users/subscription-management/subscription-change/subscription-change.component";
import {
  ResetPasswordEmailSentComponent
} from "./pages/reset-password/reset-password-email-sent/reset-password-email-sent.component";
import {
  CreateConsultantProfileComponent
} from "./pages/users/create-approved-consultant-profile/create-consultant-profile.component";
import {EditConsultantUserComponent} from "./pages/users/edit-consultant-user/edit-consultant-user.component";
import {
  ConsultantSelectAccountComponent
} from "./pages/users/consultant-select-account/consultant-select-account.component";
import {CreateConsultantUserComponent} from "./pages/users/create-consultant-user/create-consultant-user.component";
import {
  SuccessfulConsultantCreationComponent
} from "./pages/users/create-approved-consultant-profile/successful-consultant-creation/successful-consultant-creation.component";
import {
  SuccessfulConsultantCheckoutComponent
} from "./pages/users/subscription-management/success-consultant-checkout/successful-consultant-checkout.component";
import {
  CanceledConsultantCheckoutComponent
} from "./pages/users/subscription-management/canceled-consultant-checkout/canceled-consultant-checkout.component";
import {
  ConsultantAlreadyHasAccountComponent
} from "./pages/users/subscription-management/consultant-already-has-account/consultant-already-has-account.component";
import {
  SuccessfulPaymentMethodSavedComponent
} from "./pages/users/subscription-management/success-payment-method-saved/successful-payment-method-saved.component";
import {
  CanceledPaymentMethodSaveComponent
} from "./pages/users/subscription-management/canceled-payment-method-save/canceled-payment-method-save.component";
import {EmailVerificationComponent} from "./pages/users/dashboard/email-verification/email-verification.component";

const routes: Routes = [
  {
    path: 'app/unauthorized',
    component: UnauthorizedComponent,
    data: { title: 'Unauthorized'}
  },
  {
    path: 'app/logged-out',
    component: LoggedOutComponent,
    data: { title: 'Logged Out'}
  },
  {
    path: 'app/login',
    component: LoginComponent,
    data: { title: 'Login' }
  },
  {
    path: 'app/consultants/register/approval',
    component: CreateConsultantProfileComponent,
    data: { title: 'Register Consultant Profile for Approval' }
  },
  {
    path: 'app/consultants/register/checkout/success',
    component: SuccessfulConsultantCheckoutComponent,
    data: { title: 'Consultant Profile Creation Success' }
  },
  {
    path: 'app/consultants/referral-code/success',
    component: ConsultantAlreadyHasAccountComponent,
    data: { title: 'Consultant Referral Code Success' }
  },
  {
    path: 'app/consultants/register/checkout/canceled',
    component: CanceledConsultantCheckoutComponent,
    data: { title: 'Consultant Profile Creation Canceled' }
  },
  {
    path: 'app/consultants/users/register',
    component: CreateConsultantUserComponent,
    data: { title: 'Register Consultant User' }
  },
  {
    path: 'app/consultants/users/account/selection',
    component: ConsultantSelectAccountComponent,
    data: { title: 'Consultant Select Account' },
    canActivate: [AuthGuard]
  },
  {
    path: 'app/consultants/users/edit',
    component: EditConsultantUserComponent,
    data: { title: 'Edit Consultant User' },
    canActivate: [AuthGuard]
  },
  {
    path: 'app/login/reset-password-email-sent',
    component: ResetPasswordEmailSentComponent,
    data: { title: 'Reset Password Email Sent' }
  },
  {
    path: 'app/login/forgot-username',
    component: ForgotUsernameComponent,
    data: { title: 'Forgot Username' }
  },
  {
    path: 'app/login/reset-password-request',
    component: ResetPasswordRequestComponent,
    data: { title: 'Forgot Password Request' }
  },
  {
    path: 'app/login/reset-password',
    component: ResetPasswordComponent,
    data: { title: 'Reset Password Secure Link' }
  },
  {
    path: 'app/users/register',
    component: CreateEditUserComponent,
    data: { title: 'Register User'}
  },
  {
    path: 'app/users/edit',
    component: CreateEditUserComponent,
    data: { title: 'Edit User'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/view',
    component: CreateEditUserComponent,
    data: { title: 'View User'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/users/change-password',
    component: ChangePasswordComponent,
    data: { title: 'Change Your Password'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/wishlist-home',
    component: WishListListingComponent,
    data: { title: 'Your Wishlist Entries'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/wishlist-home/wishlist/create',
    component: CreateViewWishlistComponent,
    data: { title: 'Your Wishlist Entry'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/wishlist-home/wishlist/:feedbackId/view',
    component: CreateViewWishlistComponent,
    data: { title: 'Your Wishlist Entry'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard',
    component: DashboardComponent,
    data: { title: 'Dashboard'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/emails/verify',
    component: EmailVerificationComponent,
    data: { title: 'Verify Your Email'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/subscription',
    component: SubscriptionManagementComponent,
    data: { title: 'Your Subscription'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/subscription/payment/success',
    component: SuccessfulPaymentComponent,
    data: { title: 'Successful Payment'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/subscription/payment/canceled',
    component: CanceledPaymentComponent,
    data: { title: 'Canceled Payment'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/payment-method/update/success',
    component: SuccessfulPaymentMethodSavedComponent,
    data: { title: 'Successful Payment Method Update'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/payment-method/update/canceled',
    component: CanceledPaymentMethodSaveComponent,
    data: { title: 'Canceled Payment Method Update'},
    canActivate: [AuthGuard]
  }
  ,
  {
    path: 'app/users/dashboard/subscription/change/success',
    component: SuccessfulSubscriptionChangeComponent,
    data: { title: 'Successful Subscription Change'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/subscription/pricing/pay',
    component: SubscriptionPaymentComponent,
    data: { title: 'Your Subscription Pricing'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/subscription/pricing/change',
    component: SubscriptionChangeComponent,
    data: { title: 'Change Your Subscription'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/saved-searches/all',
    component: SavedSearchesContainerComponent,
    data: { title: 'All Your Saved Searches'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/saved-searches/donor/create',
    component: SavedSearchesDonorCreateEditComponent,
    data: { title: 'Create Donor Saved Search'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/saved-searches/grant/create',
    component: SavedSearchesGrantCreateEditComponent,
    data: { title: 'Create Grant Saved Search'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/saved-searches/nonprofit/create',
    component: SavedSearchesNonprofitCreateEditComponent,
    data: { title: 'Create Nonprofit Saved Search'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/saved-searches/donor/:savedSearchId/edit',
    component: SavedSearchesDonorCreateEditComponent,
    data: { title: 'Edit Donor Saved Search'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/saved-searches/donor/:savedSearchId/view',
    component: SavedSearchesDonorCreateEditComponent,
    data: { title: 'View Donor Saved Search'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/saved-searches/grant/:savedSearchId/edit',
    component: SavedSearchesGrantCreateEditComponent,
    data: { title: 'Edit Grant Saved Search'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/saved-searches/grant/:savedSearchId/view',
    component: SavedSearchesGrantCreateEditComponent,
    data: { title: 'View Grant Saved Search'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/saved-searches/nonprofit/:savedSearchId/edit',
    component: SavedSearchesNonprofitCreateEditComponent,
    data: { title: 'Edit Grant Saved Search'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/saved-searches/nonprofit/:savedSearchId/view',
    component: SavedSearchesNonprofitCreateEditComponent,
    data: { title: 'Edit Grant Saved Search'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/funding-goals/all',
    component: FundingGoalsListingComponent,
    data: { title: 'Your Funding Goals'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/funding-goals/create',
    component: FundingGoalsManagementComponent,
    data: { title: 'Add Funding Goal'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/funding-goals/:fundingGoalId/edit',
    component: FundingGoalsManagementComponent,
    data: { title: 'Edit Funding Goals'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/users/dashboard/funding-goals/:fundingGoalId/view',
    component: FundingGoalsManagementComponent,
    data: { title: 'View Funding Goals'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/search/nonprofits',
    component: SearchNonprofitsPageComponent,
    data: { title: 'Search Nonprofits'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/search/nonprofits/:nonprofitDonorId/details',
    component: SearchNonprofitsDetailsComponent ,
    data: { title: 'View Nonprofit Details'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/search/donors',
    component: SearchDonorsPageComponent,
    data: { title: 'Search Donors'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/search/donors/:nonprofitDonorId/details',
    component: SearchDonorsDetailsComponent,
    data: { title: 'View Donor Details'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/search/grants',
    component: SearchGrantsPageComponent,
    data: { title: 'Search Grants'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/search/grants/donors/:donorRecipientMappingId/recipients/:recipientId/details',
    component: SearchGrantsDetailsComponent,
    data: { title: 'View Grant Details'},
    canActivate: [AuthGuard]
  },
  {
    path: 'app/search/grants/donors/:nonprofitDonorId/details',
    component: SearchDonorsDetailsComponent,
    data: { title: 'View Donor Details'},
    canActivate: [AuthGuard]
  },
  {
    path: '',
    redirectTo: '/app/login',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    data: { title: '404 - Page Not Found'}
  }
];

/*
const routes: Routes = [
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    data: { title: 'Unauthorized'}
  },
  {
    path: 'logged-out',
    component: HomePageComponent,
    data: { title: 'Logged Out'}
  },
  {
    path: 'home',
    component: ViewEmployeeRecordsComponent,
    data: { title: 'View Employee Records' },
    canActivate: [BasicAuthGuard]
  },
  {
    path: 'reports',
    component: ViewReportsComponent,
    data: { title: 'View Reports' },
    canActivate: [BasicAuthGuard]
  },
  {
    path: 'employees/create',
    component: CreateEditEmployeeProfileComponent,
    data: { title: 'Register Employee'},
    canActivate: [BasicAuthGuard]
  },
  {
    path: 'employee/:id/edit',
    component: CreateEditEmployeeProfileComponent,
    data: { title: 'Edit Employee'},

  },
  {
    path: 'employee/:id',
    component: ViewEmployeeProfileComponent,
    data: { title: 'View Employee'},
  },
  {
    path: 'employees/:id/print',
    component: PrintPreviewProfileComponent,
    data: { title: 'Print Preview Profile'}
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    data: { title: '404 - Page Not Found'}
  }
];*/

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
